import { render, staticRenderFns } from "./DashboardFiltersModal.vue?vue&type=template&id=3a28b046&"
import script from "./DashboardFiltersModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardFiltersModal.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardFiltersModal.vue?vue&type=style&index=0&id=3a28b046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports